import styled from 'styled-components';

export default styled.div`
  font-weight: 500;
  display: grid;
  align-content: end;
  justify-content: end;
  font-family: monospace;
`;
